import { render, staticRenderFns } from "./batch-details.vue?vue&type=template&id=4b13fab8&scoped=true&"
import script from "./batch-details.vue?vue&type=script&lang=js&"
export * from "./batch-details.vue?vue&type=script&lang=js&"
import style0 from "./batch-details.vue?vue&type=style&index=0&id=4b13fab8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13fab8",
  null
  
)

component.options.__file = "batch-details.vue"
export default component.exports